<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      Animal Numbers
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>
    <template v-if="!removed">
      <subsection title="Last Year Totals" :step-name="stepName" subsection="last_year_totals">
        <dl class="dl-horizontal">
          <dt>Total Cows Wintered incl R2</dt>
          <dd class="dd-multiple-farms">{{ model.AGGREGATED_TOTALS.cows_wintered_incl_r2 || '-' }}</dd>
          <dt>R2</dt>
          <dd class="dd-multiple-farms">{{ model.AGGREGATED_TOTALS.r2 || '-' }}</dd>
          <dt>R1</dt>
          <dd class="dd-multiple-farms">{{ model.AGGREGATED_TOTALS.r1 || '-' }}</dd>
          <dt>PM Cows Pred.</dt>
          <dd class="dd-multiple-farms">{{ model.AGGREGATED_TOTALS.cows_pm_confirmed_nov || '-' }}</dd>
          <dt>Bulls</dt>
          <dd class="dd-multiple-farms">{{ model.AGGREGATED_TOTALS.bulls || '-' }}</dd>
          <dt>Beef</dt>
          <dd class="dd-multiple-farms">{{ model.AGGREGATED_TOTALS.beef || '-' }}</dd>
          <dt>Cow Deaths</dt>
          <dd class="dd-multiple-farms">{{ model.AGGREGATED_TOTALS.cow_deaths || '-' }}</dd>
          <dt>Culls</dt>
          <dd class="dd-multiple-farms">{{ model.AGGREGATED_TOTALS.cow_culls || '-' }}</dd>
        </dl>
      </subsection>

      <subsection
        :title="farm.farm_label"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-current_totals`"
        v-for="farm in model.FARMS"
        :key="farm.id"
      >
        <dl class="dl-horizontal">
          <dt>Total Cows Wintered incl R2</dt>
          <dd>{{ model[`farm_${farm.id}-cows_wintered_incl_r2`] || '-' }}</dd>

          <dt>R2</dt>
          <dd>{{ model[`farm_${farm.id}-r2`] || '-' }}</dd>

          <dt>R1</dt>
          <dd>{{ model[`farm_${farm.id}-r1`] || '-' }}</dd>

          <dt>PM Cows Pred.</dt>
          <dd>{{ model[`farm_${farm.id}-cows_pm_predicted`] || '-' }}</dd>

          <dt>Bulls</dt>
          <dd>{{ model[`farm_${farm.id}-bulls`] || '-' }}</dd>

          <dt>Beef</dt>
          <dd>{{ model[`farm_${farm.id}-beef`] || '-' }}</dd>

          <dt>Cow Deaths</dt>
          <dd>{{ model[`farm_${farm.id}-cow_deaths`] || '-' }}</dd>
          <report-comment
            :field_name="`farm_${farm.id}-cow_deaths`"
            :model="model.COMMENTS"
            title="Cow Deaths"
          ></report-comment>

          <dt>Culls</dt>
          <dd>{{ model[`farm_${farm.id}-cow_culls`] || '-' }}</dd>
          <report-comment
            :field_name="`farm_${farm.id}-cow_culls`"
            :model="model.COMMENTS"
            title="Culls"
          ></report-comment>
        </dl>
      </subsection>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'AnimalNumbers',
  mixins: [mixin],
}
</script>
